import PartySettingsForm from "../../../../../components/PartySettings/PartySettingsForm";

const SettingsEditForm = ({ vendor, onCancel, onSave }) => (
  <PartySettingsForm record={vendor} onCancel={onCancel} onSave={onSave} vendorInvoicing />
);

export default SettingsEditForm;